import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ADMIN_ROLES = ['site-admin', 'org-admin'];

const useAdminAuth = () => {
    const groupsStr = sessionStorage.getItem('groups');
    if (!groupsStr) {
        return false;
    }
    try {
        const groups: string[] = JSON.parse(groupsStr);
        return groups.some(role => ADMIN_ROLES.includes(role));
    } catch (e) {
        console.error("Failed to parse user groups from sessionStorage", e);
        return false;
    }
};

const AdminRoute: React.FC = () => {
    const isAdmin = useAdminAuth();
    return isAdmin ? <Outlet /> : <Navigate to="/" />;
};

export default AdminRoute;